export const NOOP = () => {};

export const DATETIME_FORMAT_TIME = 'HH:mm z';
export const DATETIME_FORMAT_DATE = 'MMM dd yyyy';
export const DATETIME_FORMAT_FULL = `${DATETIME_FORMAT_DATE} ${DATETIME_FORMAT_TIME}`;

export const USER_DOMAIN_KEY = 'auUserDomain';

export const EMAIL_REGEX = /^(\w.+@){0,1}((?:[a-zA-Z0-9][a-zA-Z0-9-]{1,61}[a-zA-Z0-9]{0,61}\.)+[a-zA-Z]{2,})$/;

export const AU_ACCOUNT_ID = "79000000-0000-0000-0000-000000000000";

export const TAB_KEY            = 'Tab';
export const ENTER_KEY          = 'Enter';
export const UP_KEY             = 'ArrowUp';
export const DOWN_KEY           = 'ArrowDown';
export const ESCAPE_KEY         = 'Escape';
export const BACKSPACE_KEY      = 'Backspace';
export const DELETE_KEY         = 'Delete';
export const FORWARD_SLASH_KEY  = '/';

export const DEV_PORTAL_LINK  	= 'devportal-link';
export const FEEDBACK_LINK    	= 'feedback-link';
export const HELP_LINK        	= 'help-link';
export const INSIGHTS_LINK    	= 'insights-link';
export const TMC_METRICS_LINK   = 'tmc-metrics-link';
export const CONSOLE_LINK     	= 'console-link';
export const STATUS_PAGE_LINK  = 'status-page-link';

export const PROD_LINK    = 'https://console.autonomic.ai';
export const STAGING_LINK = 'https://console.beta.autonomic.ai';
export const DEV_LINK     = 'https://console.dev.instrumented-mile.com';

export const PROD_ENV = 'production';
export const STAGING_ENV = 'staging';
export const DEV_ENV = 'dev';

export const SERVICE_STATUS_LINK = 'https://status.autonomic.com/';
export const TMC_INSTANCES_LINK = 'https://developer.autonomic.ai/getting-started/getting-started-on-the-tmc-platform/about-the-tmc/tmc-instances/tmc-instances';
export const IAM_SERVICE_LINK = 'https://developer.autonomic.ai/getting-started/getting-started-on-the-tmc-platform/about-the-tmc/permissions-policies-and-roles/roles--permissions/';
export const SUPPORT_LINK = 'https://ford.atlassian.net/servicedesk/customer/portal/1131/group/1298';


//This is for the ordered set of links to insure that link order stays the same.
export const tmcLinkTypes = Object.freeze([
  DEV_PORTAL_LINK,
  HELP_LINK,
  STATUS_PAGE_LINK,
  TMC_METRICS_LINK
]);